// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1ZmGY","actions":"GroupTable_actions__BIt_T","deleteModalFooter":"GroupTable_deleteModalFooter__3Vwjv"};